// assets
import UserOutlined from '@ant-design/icons/UserOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import SwapOutlined from '@ant-design/icons/SwapOutlined';

// icons
const icons = { UserOutlined, TeamOutlined, SwapOutlined };

// ==============================|| MENU ITEMS - MEMBERS ||============================== //

const members = {
  id: 'members',
  title: 'Members',
  type: 'collapse',
  url: '/members', // Add URL for clickable behavior
  icon: icons.UserOutlined,
  permission: {
    module: 'members',
    level: 10 // View permission required
  },
  children: [
    {
      id: 'dependents',
      title: 'Dependents',
      type: 'item',
      url: '/dependents',
      icon: icons.TeamOutlined,
      permission: {
        module: 'members',
        level: 10 // View permission required (dependents use members permissions)
      }
    },
    {
      id: 'centre-transfer',
      title: 'Centre Transfer',
      type: 'item',
      url: '/members/centre-transfer',
      icon: icons.SwapOutlined,
      permission: {
        module: 'members',
        level: 10
      }
    }
  ]
};

export default members;

